import { InsightsSpendingSkeleton } from '@/components/ui'
import {
  useFetchTransactions,
  useLoadingTransactions,
  useTransactions,
} from '@/modules/projects'
import { CategoriesInsights } from '../components'
import { useCategoryBreakdown } from '../hooks'

interface CategoriesPageProps {
  slug: string
}

export function CategoriesPage({ slug }: CategoriesPageProps) {
  useFetchTransactions(slug)

  const transactions = useTransactions()
  const isLoading = useLoadingTransactions()

  const breakdown = useCategoryBreakdown(transactions)

  if (isLoading) return <InsightsSpendingSkeleton />

  return <CategoriesInsights breakdown={breakdown} />
}
